import './App.scss';
import Header from '../Tools/Header/Header';
// import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Offline, Online } from "react-detect-offline";
import Main from './Main';

// blogs images
import unlock from '../Images/unlock.png'
import reload from '../Images/reload.png'
import callbtn from '../Images/telephone.png'
import PopUp from '../Tools/PopUp/PopUp';
import Footer from '../Tools/Footer/Footer';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const [showVerify, setShowVerify] = useState(true)
  const [status, setStatus] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()
  const [BookAnAppointment, setBookAnAppointment] = useState(true);

  const url = new URL(window.location.href);
  const [CitiesData, setCitiesData] = useState({});

  const [CitiePhone, setCitiePhone] = useState(url.searchParams.get('cp') ? url.searchParams.get('cp') : "866-950-4606");
  useEffect(() => {
    (async () => {

      // google //
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          // console.log(data.results[0])
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }

      // Microsoft //
      if (url.searchParams.get('spg') == "m") {
        const CitiesZipMS2 = (await import('./CitiesZipMS2.js')).default;
        if (CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataMS = (await import('./CitiesDataMS.js')).default;
          if (CitiesDataMS.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataMS.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }


      // OpenAI ads (spg=o): location comes from the open_ai_location param,
      // e.g. ?open_ai_location=West-Palm-Beach,FL -> { City: "West Palm Beach", Full: "West Palm Beach, FL" }
      if (url.searchParams.get('spg') == "o") {
        const loc = url.searchParams.get('open_ai_location');
        if (loc && loc.includes(',')) {
          const Full = loc.split(',').map(p => p.trim().replace(/-/g, ' ')).join(', ');
          setCitiesData({ City: Full.split(',')[0].trim(), Full });
        } else {
          setCitiesData({});
        }
      }

      // const res1 = await fetch('https://bhocs-10ec.restdb.io/', {
      //   method: 'GET',
      //   headers: {
      //     'Access-Control-Allow-Origin': '*',
      //     'Content-Type': 'application/json',
      //     'x-apikey': '66fddf40f368d41d0d577784',
      //     'Access-Control-Allow-Credentials': 'true',
      //     'cache-control':'no-cache',
      //     'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
      //     'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
      //   }
      // });
      // const data1 = await res1.json()
      // console.log(data1)



      if (showVerify == true) {
        document.body.style.overflow = "hidden"
        document.body.style.overflow = "scroll"
      } else {
        document.body.style.overflow = "scroll"
      }
      setTimeout(() => {
        const checkpop = localStorage.getItem("showPopUp");
        if (checkpop) {
          setShowPopUp(false)
        } else {
          setShowPopUp(true)
        }
      }, 5000);
      window.addEventListener('online', () => setStatus(true))
      window.addEventListener('offline', () => setStatus(false))
    })();
  }, [showVerify, status]);

  const navigateTo = (page) => {
    navigate('/' + page)
    setShowMenu(false)

  }
  const locationsMain = [
    {
      "Location": "Austin",
      "Phone": "737-367-2143",
      "Address": [
        {
          "Location1": "Austin",
          "Address1": "9415 Burnet Rd, Austin, Texas 78758",
        },
        {
          "Location1": "San Antonio",
          "Address1": "9504 N IH-35, San Antonio, TX 78233",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1ZFzBzklHnjRzKFG32H-Wn9TxmmpdSu8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chicago",
      "Phone": "872-288-0977",
      "Address": [
        {
          "Location1": "Chicago",
          "Address1": "2211 N Elston Ave, Chicago, IL 60614",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Y2d_hgj3Z2rnaUFE90sd_RmsM456iVI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Connecticut",
      "Phone": "475-447-1126",
      "Address": [
        {
          "Location1": "Hartford",
          "Address1": "64 Oakland Ave, East Hartford, CT 06108",
        },
        {
          "Location1": "Hamden",
          "Address1": "2666 State St, Hamden, CT 06517",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1arTs8xd0v35vvinYSHJY5y2cU9EPi7g&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Houston",
      "Phone": "346-614-4773",
      "Address": [
        {
          "Location1": "Houston",
          "Address1": "2705 Blodgett St, Houston, TX 77004",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1KYM_Tnx3zFBA9vvUnimOYgc3YHLlLBE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Kansas",
      "Phone": "913-404-4872",
      "Address": [
        {
          "Location1": "Kansas",
          "Address1": "3947 Broadway St, Kansas City, MO 64111",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1cyZUyG54v6vYltik3L6Zbfpd7Cm6gW0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Los Angeles",
      "Phone": "213-698-5905",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "1271 Saviers Rd, Oxnard, CA 93033",
        },
        {
          "Location1": "Los Angeles",
          "Address1": "6222 Wilshire Blvd, Los Angeles, CA 90048",
        },
        {
          "Location1": "Riverside",
          "Address1": "3890 11th St, Riverside, CA 92501",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Minneapolis",
      "Phone": "651-273-1473",
      "Address": [
        {
          "Location1": "Minneapolis",
          "Address1": "201 Main St SE, Minneapolis, MN 55414",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=12fYx_1i1hARDMU9SIht0RVfutlIhFfM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Jersey",
      "Phone": "732-466-6572",
      "Address": [
        {
          "Location1": "Moorestown",
          "Address1": "300 Harper Dr, Moorestown, NJ 08057",
        },
        {
          "Location1": "Newark",
          "Address1": "390 Broad St, Newark, NJ 07104",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wCzvOW3l5LHsYiJ8weh2xoTKcaS8nb8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Orlando",
      "Phone": "407-337-2852",
      "Address": [
        {
          "Location1": "Orlando",
          "Address1": "37 N Orange Ave, Orlando, FL 32801",
        },
        {
          "Location1": "Jacksonville",
          "Address1": "4168 Southpoint Park Way, Jacksonville, FL 32216",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1NjUXcA6OX2tJZ-Xht56H0wZZNLiGbeQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Seattle",
      "Phone": "206-875-2251",
      "Address": [
        {
          "Location1": "Seattle",
          "Address1": "464 12th Ave, Seattle, WA 98122",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wpt9MtPAqDTtBJ8BGNjpjdKnSZ4IYxA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Saint Louis",
      "Phone": "314-886-8145",
      "Address": [
        {
          "Location1": "Saint Louis",
          "Address1": "399 N Euclid Ave, Saint Louis, MO 63108",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=15wIgRS6l1GFxtX5Ongf6ArLwOsAcML0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tampa",
      "Phone": "813-733-7346",
      "Address": [
        {
          "Location1": "Tampa",
          "Address1": "1902 W Main St, Tampa, FL 33607",
        },
        {
          "Location1": "Fort Myers",
          "Address1": "15050 Elderberry Ln, Fort Myers, FL 33907",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1sLBr2KXbf8fs1MWdeT9eGkrQDZ-gqXk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Denver",
      "Phone": "720-704-2987",
      "Address": [
        {
          "Location1": "Denver",
          "Address1": "543 Santa Fe Dr, Denver, CO 80204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-dZYn4IqFRsZTQoHlvmE7CAay5fosYQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charlotte",
      "Phone": "980-436-3595",
      "Address": [
        {
          "Location1": "Charlotte",
          "Address1": "4326 Monroe Rd, Charlotte, NC 28205",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mhFU5wqgrPgYF_kqrRbwxfZT9SGr_BI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Nashville",
      "Phone": "615-437-6099",
      "Address": [
        {
          "Location1": "Nashville",
          "Address1": "2910 Poston Ave, Nashville, TN 37203",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1b1273439kLELw9wSSiqD-_WhlAKGl18&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Dallas",
      "Phone": "469-902-3045",
      "Address": [
        {
          "Location1": "Dallas",
          "Address1": "5701 Maple Ave, Dallas, TX 75235",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1Jq7olr9nIOOlBvrge9gBtQZ1gv38eSk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Atlanta",
      "Phone": "678-680-6382",
      "Address": [
        {
          "Location1": "Atlanta",
          "Address1": "1200 White St SW, Atlanta, GA 30310",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1sIJWXQRLTPmw4YVHmgahsrJWSgd1VEM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Fransisco",
      "Phone": "415-340-5954",
      "Address": [
        {
          "Location1": "San Fransisco",
          "Address1": "1485 Bay Shore Blvd, San Francisco, CA 94124",
        },
        {
          "Location1": "Sacramento",
          "Address1": "2120 P St, Sacramento, CA 95816",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Jose",
      "Phone": "408-539-2676",
      "Address": [
        {
          "Location1": "San Jose",
          "Address1": "695 N 1st St, San Jose, CA 95112",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1VTJ5eC5cJ1lvDHm3-xJ-8DaTl412cv8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Detroit",
      "Phone": "313-922-7886",
      "Address": [
        {
          "Location1": "Detroit",
          "Address1": "438 Macomb St, Detroit, MI 48226",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1EbsUpXTpW8B457T-xz2aBMfyTDb7EYs&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New York",
      "Phone": "516-970-4945",
      "Address": [
        {
          "Location1": "New York",
          "Address1": "10657 160th St, Jamaica, NY 11433",
        },
        {
          "Location1": "Farmingdale",
          "Address1": "2357 Broadhollow Rd, Farmingdale, NY 11735",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=17OjSFSNGhqK3w-aOCSkHNgDzV8ybfjc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Ohio",
      "Phone": "330-295-3631",
      "Address": [
        {
          "Location1": "Fort Wayne",
          "Address1": "6069 Stellhorn Rd, Fort Wayne, IN 46815",
        },
        {
          "Location1": "Toledo",
          "Address1": "5153 Glendale Ave, Toledo, OH 43614",
        },
        {
          "Location1": "Dayton",
          "Address1": "3739 Inpark Cir, Dayton, OH 45414",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1T_-ChddVtp0sNncfKQ1_eqiV2h6tCxc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Philadelphia",
      "Phone": "215-261-7009",
      "Address": [
        {
          "Location1": "Philadelphia",
          "Address1": "1501 N Broad St, Philadelphia, PA 19122",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1D8wzDRrVB_qzrwo_8RkQA30RgZu0Q2I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Maryland",
      "Phone": "443-381-6892",
      "Address": [
        {
          "Location1": "College Park",
          "Address1": "4907 Niagara Rd, College Park, MD 20740",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1hFBKavqDPHMd0GUtJ-dU5YcIwaZPHZg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Miami",
      "Phone": "786-981-8328",
      "Address": [
        {
          "Location1": "Miami",
          "Address1": "7275 NW 1st Ct, Miami, FL 33150",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-hiS50ZCrpLPWXbYvKYv5tJyxeyogbo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Sacramento",
      "Phone": "916-674-0535",
      "Address": [
        {
          "Location1": "Sacramento",
          "Address1": "646 El Camino Ave, Sacramento, CA 95815",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
  ]

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>


      {/* Book an appointment */}
      {/* {showPopUp ?
        <PopUp CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} />
        : null} */}
      {/* Menu */}
      {showMenu ? <Menu CitiePhone={CitiePhone} navigateTo={navigateTo} setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {location.pathname == "/apply" || location.pathname == "/thankscontact" || location.pathname == "/thanks" || location.pathname.match("/portal/:*") ? null : <Header CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} showMenu={showMenu} navigateTo={navigateTo} setShowMenu={setShowMenu} />}
      {/* Main */}
      <Main locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} WebSitePages={[]} />
      {/* Footer */}
      {location.pathname.startsWith("/local") || location.pathname.startsWith("/book") || location.pathname == "/thanks" || location.pathname == "/thankscontact" || location.pathname.match("/portal/:*") ? null : <Footer locationsMain={locationsMain} CitiePhone={CitiePhone} navigateTo={navigateTo} />}

      {/* oNLINE */}
      {location.pathname != "/book" ?
        <div className="AppCall">
          <div className="AppCallbox">
            <a className='callButtonMainApp' href={`#book`}> <img src={require(`../Images/book.png`)} alt="" />SCHEDULE ONLINE</a>
            <a className='bookButtonMainApp' href={`tel:${CitiePhone}`}>Get Help Now! Call us at <span>{CitiePhone}</span></a>
          </div>
        </div>
        :
        null
      }


    </div>
  );
}

export default App;
